<template>
  <div>
    <v-btn class="btn-primary" @click="submitOrder" :loading="submitting">
      Finalize and Send
    </v-btn>
  </div>
</template>

<script>
import client from "@/lib/ApiClient"
import { mapActions, mapGetters } from "vuex"

export default {
  data() {
    return {
      submitting: false
    }
  },

  computed: {
    ...mapGetters(["orderUid", "upperScanAnalysis", "lowerScanAnalysis"])
  },

  methods: {
    ...mapActions(["setOrderDetails"]),

    async submitOrder() {
      if (this.submitting) return
      this.submitting = true
      const dentateAnalyses = {
        upper: this.upperScanAnalysis,
        lower: this.lowerScanAnalysis
      }
      try {
        const order = await client.instance.orders.submitOrder(
          this.orderUid,
          dentateAnalyses
        )
        this.setOrderDetails(order)
      } catch (err) {
        console.error(err)
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>
